<template>
    <div class="saleEchart" ref="myEchart"></div>
</template>

<script>
    import echarts from 'echarts';
    import {option} from './option.js';

    export default {
        name: "saleEchart",
        data() {
          return {
            chart: null
          }
        },
        mounted(){
          let myChart  = echarts.init(this.$refs.myEchart);
          myChart.setOption(option);
        }
    }
</script>

<style scoped>
  .saleEchart{
    width: 78%;
    height: 544px;
    margin-right: 21px;
  }
</style>
